
import './OnRent.css';
import Liability from '../Liability/Liability';
import PhysicalDamage from '../PhysicalDamage/PhysicalDamage';
import Billing from '../Billing/Billing';
const OnRent = ()=>{
    return(
        <>
            <section className="onRentMain" id="onRentMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="headOnRent">
                                <h2><span>On-Rent coverage.</span> Only pay when the vehicle is rented.</h2>
                            </div>
                        </div>
                    </div>
                    <div className="onRentOuter">

                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a className="nav-link active" data-bs-toggle="tab" href="#onRent_1">Liability</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#onRent_2">Physical Damage</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#onRent_3">SLI Protection</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#onRent_4">Business Type</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#onRent_5">Primary Coverage</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#onRent_6">A-Rated</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#onRent_7">Billing</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#onRent_8">Fleet Size</a>
                            </li>
                        </ul>
                    
                        <div className="tab-content">
                            {/* START Tab 1 */}
                            <div className="tab-pane active" id="onRent_1">
                                    <Liability/>
                            </div>

                            {/* START Tab 2 */}
                            <div className="tab-pane fade" id="onRent_2">
                                <PhysicalDamage/>
                            </div> 

                            {/* START Tab 3 */}
                            <div className="tab-pane fade" id="onRent_3">
                                <div className='row'>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentLeft'>
                                            <figure>
                                                <img className="img-fluid" src="/img/rentshield/onRent_3.webp" alt="Supplemental Liability"/>
                                            </figure>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentRight'>
                                            <h3><span>Supplemental Liability</span> Insurance up to $1M</h3>
                                            <ul>
                                                <li>
                                                    <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                    <h4>Comprehensive Third-Party Liability Protection</h4>
                                                    <small>Adds an additional safety net beyond your primary insurance limits.</small>
                                                </li>
                                                <li>
                                                    <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                    <h4>Coverage up to $1M Beyond Primary</h4>
                                                    <small>Ensures substantial financial protection against large claims.</small>
                                                </li>
                                                <li>
                                                    <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                    <h4>Universal Applicability Across Vehicle Classes</h4>
                                                    <small>Covers bodily injury and property damage claims made by others.</small>
                                                </li>
                                                <li>
                                                    <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                    <h4>Substantial Financial Safeguard for Large Claims</h4>
                                                    <small>Applicable to economy cars, luxury vehicles, and everything in between.</small>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div> 

                            {/* START Tab 4 */}
                            <div className="tab-pane fade" id="onRent_4">
                                <div className='row'>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentLeft'>
                                            <figure>
                                                <img className="img-fluid" src="/img/rentshield/onRent_4.webp" alt="Business Type"/>
                                            </figure>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentRight'>
                                            <h3>Coverage for all <span>Business Types</span></h3>
                                            <ul>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Car Rental Agencies</h4>
                                                </li>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Service & Repair / Auto body</h4>
                                                </li>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Car Sharing Marketplaces</h4>
                                                </li>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Auto Dealerships</h4>
                                                </li>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Hotels/Vacation Rental</h4>
                                                </li>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Property Management</h4>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div> 

                            {/* START Tab 5 */}
                            <div className="tab-pane fade" id="onRent_5">
                                <div className='row'>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentLeft'>
                                            <figure>
                                                <img className="img-fluid" src="/img/rentshield/onRent_5.webp" alt="Primary Coverage"/>
                                            </figure>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentRight'>
                                            <h3><span>Primary Coverage</span> on Every Rental</h3>
                                            <p>Primary coverage offers first-in-line protection, responding immediately to claims without relying on other policies. 
                                            Enjoy faster resolutions and greater peace of mind for every rental, while minimizing potential out-of-pocket expenses.</p>
                                        </div>
                                    </div>
                                </div>
                            </div> 

                                {/* START Tab 6 */}
                            <div className="tab-pane fade" id="onRent_6">
                                <div className='row'>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentLeft'>
                                            <figure>
                                                <img className="img-fluid" src="/img/rentshield/onRent_6.webp" alt="A Rated"/>
                                            </figure>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentRight'>
                                            <h3>Highest <span>Quality Insurance</span> Standards</h3>
                                            <ul>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Financial Stability</h4>
                                                <small>A-rated insurers have the reserves to cover claims, even in large-scale or unexpected events.</small>
                                                </li>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Reliable Claims Processing</h4>
                                                <small>Dependable, timely payouts eliminate delays or disputes, ensuring you get the coverage you deserve.</small>
                                                </li>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Long-Term Security</h4>
                                                <small>High ratings reflect a proven track record, reducing the risk of insolvency and guaranteeing sustained protection.</small>
                                                </li>
                                                <li>
                                                <img width="24px" height="24px" src="/img/rentshield/check_blue.svg" alt="icon"/>
                                                <h4>Confidence and Compliance</h4>
                                                <small>Enjoy peace of mind knowing you're backed by trusted insurers who meet stringent business and government standards.</small>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div> 

                                {/* START Tab 7 */}
                            <div className="tab-pane fade" id="onRent_7">
                                <Billing/>
                            </div> 

                            {/* START Tab 8 */}
                            <div className="tab-pane fade" id="onRent_8">
                                <div className='row'>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentLeft'>
                                            <figure>
                                                <img className="img-fluid" src="/img/rentshield/onRent_8.webp" alt="Billing"/>
                                            </figure>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-12 col-sm-12'>
                                        <div className='onRentRight'>
                                            <h3>Coverage for <span>all rental fleet sizes</span></h3>
                                            <p>Our On-Rent Coverage protects rentals of any size, offering flexible, cost-effective protection only when in use. 
                                            Enjoy peace of mind knowing your fleet is safeguarded during every rental trip.</p>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                
                    </div>
                </div>
            </section>
        </>
    )
}

export default OnRent;